module.exports = "/wp-content/themes/lanthiaresort/modules/public/images/1a5f86c63f84893f5e3fc0c91ae36156.png";